<template>
  <connections-container-index />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import ConnectionsContainerIndex from "./connections-container/connections-container.index.vue";
import { useI18n } from "vue-i18n";
import { usePageMetaStore } from "@/store/pageMeta.store";

const { t } = useI18n();
const pageMetaStore = usePageMetaStore();

onMounted(() => {
  pageMetaStore.setPageTitle({
    title: t("connections"),
  });
});
</script>
